import { Flask, Package, Ruler, SealCheck } from '@phosphor-icons/react'
import { ROLES } from '@/auth/roles'
import type { ConsoleDetailRoute, ConsoleSection } from '../routes'
import { LabLimitsPage } from '../pages/lab/LabLimitsPage'
import { LabReportDetailPage } from '../pages/lab/LabReportDetailPage'
import { LabReportsPage } from '../pages/lab/LabReportsPage'
import { PackLotDetailPage } from '../pages/lab/PackLotDetailPage'
import { PackLotsPage } from '../pages/lab/PackLotsPage'
import { ReleaseQueuePage } from '../pages/lab/ReleaseQueuePage'

/** Supervisors and quality release people (admins pass every role check). */
const PACK_LAB = [ROLES.SUPERVISOR, ROLES.QUALITY_RELEASE, ROLES.CENTRAL_ADMIN]

/** Sidebar entries for this area (in sidebar order). */
export const LAB_SECTIONS: ConsoleSection[] = [
  { path: 'pack-lots', label: 'Pack lots', icon: Package, group: 'Pack & lab', element: <PackLotsPage />, roles: PACK_LAB },
  { path: 'release', label: 'Release queue', icon: SealCheck, group: 'Pack & lab', element: <ReleaseQueuePage />, roles: PACK_LAB },
  { path: 'lab-reports', label: 'Lab reports', icon: Flask, group: 'Pack & lab', element: <LabReportsPage />, roles: PACK_LAB },
  { path: 'lab-limits', label: 'Lab limits', icon: Ruler, group: 'Pack & lab', element: <LabLimitsPage />, roles: PACK_LAB },
]

/** Detail pages for this area: routed, not in the sidebar. */
export const LAB_DETAIL_ROUTES: ConsoleDetailRoute[] = [
  { path: 'pack-lots/:id', element: <PackLotDetailPage />, roles: PACK_LAB },
  { path: 'lab-reports/:id', element: <LabReportDetailPage />, roles: PACK_LAB },
]
